import Proptypes from 'prop-types'
import { addBrToText } from 'utils'
import { isPartVisible } from 'utils/displayByDateAndTime'
import Picture from 'components/Picture'
import SketchFab from 'components/SketchFab'
import BeforeAfter from 'components/BeforeAfter'
import Panorama360 from 'components/Panorama360'
import SlideShow from 'components/SlideShow'

export const PartImageAnd3D = ({ part, themeInfos }) => {
  if (!isPartVisible(part)) return null

  switch (part.type) {
    case 'Picture':
    case 'PictureUrl':
      return (
        <Picture
          alt={part.alt}
          url={part.url || part.gif}
          link={part.link}
          title={part.title}
          withZoom={part.withZoom}
          legend={addBrToText(part.legend, 'part-lgd')}
          legendSize={part.legendSize}
          newTab={part.newTab}
          hideLinkIcon={part.hideLinkIcon}
        />
      )
    case 'Giphy':
      return (
        <Picture
          alt={part.alt}
          url={part.url || part.gif}
          link={part.link}
          withZoom={part.withZoom}
          legend={addBrToText(part.legend, 'part-lgd')}
          legendSize={part.legendSize}
          isGiphy
          fullSizeGif={part.fullSizeGif}
        />
      )
    case 'SketchFab': {
      return <SketchFab part={part} />
    }
    case 'BeforeAfter': {
      return <BeforeAfter part={part} />
    }
    case 'Panorama360':
      return <Panorama360 part={part} />
    case 'SlideShow':
      return <SlideShow part={part} themeInfos={themeInfos} />
    default:
      return null
  }
}

PartImageAnd3D.propTypes = {
  part: Proptypes.object,
  themeInfos: Proptypes.object,
}

export default PartImageAnd3D
